import { IStateTheme } from '@/store/modules/theme'

export default {
  switchTheme(state: IStateTheme) {
    state.dark = !state.dark
  }
}
